import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function AndorraResidencyGoldenVisa() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.andorra-residency-golden-visa.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/andorra-residency-golden-visa"
            />

            <IntroSection
                title={tp('intro.title')}
                description={tp('intro.description')}
                imageSrc={require('../../../assets/images/Andorra-la-Vella-Modern-Urban-Skyline.jpg')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                        end={tp('why.end')}
                    />

                    <InfoBlocks
                        title={tp('investment.title')}
                        subtitle={tp('investment.subtitle')}
                        blocks={obj('investment.blocks')}
                        end={tp('investment.end')}
                    />

                    <WhySection
                        title={tp('process.title')}
                        subtitle={tp('process.subtitle')}
                        blocks={[{ items: obj('process.items') }]}
                        end={tp('process.end')}
                    />

                    <ServiceCards
                        title={tp('who.title')}
                        services={obj('who.items')}
                    />

                    <Testimonials
                        title={tp('testimonials.title')}
                        paragraph={tp('testimonials.paragraph')}
                        testimonials={obj('testimonials.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <DetailsSection
                        title={tp('whyUs.title')}
                        subtitle={tp('whyUs.subtitle')}
                        items={obj('whyUs.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
